// extracted by mini-css-extract-plugin
export default {"internalDashboard":"styles_internalDashboard__r8pY5"};